import AxisRefComponent from './axis-ref-component';
import { getCoordinates } from '@fusioncharts/utils/src/scale-utils/polar-util';
import { pluckNumber } from '../lib';
import { addDep } from '../dependency-manager';
import axisRefPolarAnimation from './axis-ref-polar.animation';

const M = 'M',
  Z = 'Z',
  L = 'L',
  getRadius = (axis, point) => {
    let scale = axis.getScale(),
      range = axis.config.axisRange;

    return Math.abs(scale.getRangeValue(point) - scale.getRangeValue(range.min));
  };
addDep({
  name: 'axisRefPolarAnimation',
  type: 'animationRule',
  extension: axisRefPolarAnimation
});
class AxisRefPolarVisual extends AxisRefComponent {
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'axisRefVisuals';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'axisRefVisualsPolar';
  }
  /**
   * Decides the type of line to draw
   *
   * @param {any} lineInfo
   * @param {any} axis
   * @memberof AxisRefPolarVisual
   */
  createLine (lineInfo, axis) {
    let axisRef = this;
    if (axis.getName() === 'polarCategory') {
      return axisRef.createNormalLine(lineInfo, axis);
    } else if (axis.getName() === 'numeric') {
      return axisRef.createRadialLine(lineInfo, axis);
    }
  }

  /**
   * Creates radial line
   *
   * @param {any} lineInfo
   * @param {any} axis
   * @returns {any}
   * @memberof AxisRefPolarVisual
   */
  createRadialLine (lineInfo, axis) {
    let axisRef = this,
      xAxis = axisRef.getFromEnv('xAxis')[0],
      xAxisConfig = xAxis.config,
      category = xAxisConfig.tickValues.tickValue,
      yAxis = axis,
      axisRefConfig = axisRef.config,
      containersArr = axisRefConfig.containers,
      container = containersArr[lineInfo.layer],
      animationManager = axisRef.getFromEnv('animationManager'),
      toolTipController = axisRef.getFromEnv('toolTipController'),
      i,
      key,
      min,
      max,
      radius,
      lineAttr = lineInfo.attr,
      pathAr = [M],
      coordinate,
      compId = yAxis.getId(),
      eleId = lineInfo.id || lineInfo.from,
      lineEleId = compId + '_' + eleId,
      handlers = lineInfo.handlers,
      element = axisRef.getGraphicalElement(lineEleId);

    radius = getRadius(yAxis, lineInfo.from);
    min = 0;
    max = category ? category.length - 1 : 0;

    for (i = min; i <= max; i++) {
      coordinate = getCoordinates({
        radius: radius,
        theta: i
      }, xAxis);
      pathAr.push(coordinate.x, coordinate.y, L);
    }
    pathAr.pop();
    pathAr.push(Z);

    lineAttr.path = pathAr;

    element = axisRef.addGraphicalElement(lineEleId, animationManager.setAnimation({
      container,
      el: element || 'path',
      attr: lineAttr,
      component: axisRef,
      label: 'path'
    }));

    if (lineInfo.toolText) {
      toolTipController.enableToolTip(element, lineInfo.toolText);
    } else {
      toolTipController.disableToolTip(element);
    }

    for (key in handlers) {
      if (handlers.hasOwnProperty(key)) {
        element.on(key, handlers[key].bind(axis));
      }
    }
    return [lineEleId];
  }

  /**
   * Draws normal line
   *
   * @param {any} lineInfo
   * @param {any} axis
   * @memberof AxisRefPolarVisual
   */
  createNormalLine (lineInfo, axis) {
    let axisRef = this,
      axisRefConfig = axisRef.config,
      axisConfig = axis.config,
      radius = pluckNumber(axisConfig.radius, 0),
      pathAr = [M],
      containersArr = axisRefConfig.containers,
      container = containersArr[lineInfo.layer],
      animationManager = axisRef.getFromEnv('animationManager'),
      toolTipController = axisRef.getFromEnv('toolTipController'),
      coordinate,
      key,
      centerX = axisConfig.axisDimention.centerX,
      centerY = axisConfig.axisDimention.centerY,
      compId = axis.getId(),
      eleId = lineInfo.id || lineInfo.from,
      lineEleId = compId + '_' + eleId,
      handlers = lineInfo.handlers,
      element = axisRef.getGraphicalElement(lineEleId);

    pathAr.push(centerX, centerY, L);
    coordinate = getCoordinates({
      radius: radius,
      theta: lineInfo.from
    }, axis);

    pathAr.push(coordinate.x, coordinate.y);
    lineInfo.attr.path = pathAr;

    element = axisRef.addGraphicalElement(lineEleId, animationManager.setAnimation({
      container,
      el: element || 'path',
      attr: lineInfo.attr,
      component: axisRef,
      label: 'path'
    }));

    if (lineInfo.toolText) {
      toolTipController.enableToolTip(element, lineInfo.toolText);
    } else {
      toolTipController.disableToolTip(element);
    }

    for (key in handlers) {
      if (handlers.hasOwnProperty(key)) {
        element.on(key, handlers[key].bind(axis));
      }
    }
    return [lineEleId];
  }
  // eslint-disable-next-line
  createBand () {
    // super.createBand(x, y);
    return [];
  }
}

export default AxisRefPolarVisual;
